(function () {
    "use strict";

    angular.module("iMatApp")
        .component("quantity", quantityComponent());

    function quantityComponent() {
        return {
            bindings: {
                value: '<',
                minValue: '@',
                maxValue: '@',
                valueChanged: '&'
            },

            templateUrl: '/Scripts/iMatApp/views/quantityTemplate.html',
            controller: QuantityComponentController,
            controllerAs: "quantityViewModel"
        };
    }

    QuantityComponentController.$inject = [];

    function QuantityComponentController() {
        var vm = this;

        vm.maxLength = null;
        vm.quantity = quantity;

        vm.decrementQuantity = decrementQuantity;
        vm.incrementQuantity = incrementQuantity;

        vm.onKeyDown = onKeyDown;

        // it will be called once all bindings are initialized
        this.$onInit = activate;
        this.$onChanges = bindingsChanged;

        var maxValue, minValue;

        // -----------------------------------------------------------------------------------

        function activate() {
            vm.maxLength = vm.maxValue.length;
            minValue = parseInt(vm.minValue, 10);
            maxValue = parseInt(vm.maxValue, 10);
        }

        function bindingsChanged(changes) {
            if (changes.value && changes.value.currentValue !== vm.value) {
                setQuantity(changes.value.currentValue);
            }
        }

        function quantity(strValue) {
            if (angular.isUndefined(strValue)) {
                return parseInt(vm.value, 10);
            }

            setQuantity(strValue);
            return angular.undefined;
        }

        function incrementQuantity() {
            setQuantity(quantity() + 1);
        }

        function decrementQuantity() {
            setQuantity(quantity() - 1);
        }

        function onKeyDown($event) {
            // arrow up
            if ($event.which === 38) {
                incrementQuantity();
            }

            // arrow down
            if ($event.which === 40) {
                decrementQuantity();
            }
        }

        // -----------------------------------------------------------------------------------

        function setQuantity(strValue) {
            var newValue;

            var value = parseInt(strValue, 10);
            if (isNaN(value)) {
                value = minValue;
            }

            if (value > maxValue) {
                newValue = maxValue;
            } else if (value < minValue) {
                newValue = minValue;
            } else {
                newValue = value;
            }

            if (newValue !== vm.value) {
                vm.value = newValue;
                vm.valueChanged({ value: newValue });
            }
        }
    }
})();